export default {
  String: {
    PlainDate: "dev.superego:String.PlainDate",
    PlainTime: "dev.superego:String.PlainTime",
    Instant: "dev.superego:String.Instant",
    Markdown: "dev.superego:String.Markdown",
  },
  Number: {
    Integer: "dev.superego:Number.Integer",
  },
  JsonObject: {
    ExcalidrawDrawing: "dev.superego:JsonObject.ExcalidrawDrawing",
    GeoJSON: "dev.superego:JsonObject.GeoJSON",
    TiptapRichText: "dev.superego:JsonObject.TiptapRichText",
  },
} as const;
